import React, { Component } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import logo from "../../assets/images/LOGO_SIMA-02 (1).jpg";
import { NavLink } from "react-router-dom";
import axios from "axios";
import Global from "../../Global";
import swal from "sweetalert";

class MenuAdmin extends Component {
  //url base
  url = Global.url;
  //header
  config = {
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
  };

  state = {
    visible: false,
    role: "",
  };
  openDrawer = () => {
    if (this.state.visible === false) {
      this.setState({
        visible: true,
      });
      this.role();
    } else {
      this.setState({
        visible: false,
      });
    }
  };
  role = () => {
    axios
      .get(this.url + "user", this.config)
      .then((user) => {
        axios
          .post(
            this.url + "login",
            { email: user.data.email, password: "1234" },
            this.config
          )
          .then((res) => {
            if(res.data){
              this.setState({
                role:res.data[1][0].name,
              })
            }

          })
          .catch((err) => {
            swal("Error de autenticación de usuario!!", { icon: "warning" });
          });
      })
      .catch((err) => {
        swal("No se pudo encontrar el usuario", { icon: "warning" });
      });
  };
  render() {
    return (
      <>
        {this.state.visible === true ? (
          <div className="drawer">
            <div className="sidenav">
              <header id="header">
                <div className="center">
                  {/*LOGO*/}
                  <div id="logo-drawer">
                    <img src={logo} className="app-logo" alt="logotipo" />
                  </div>
                </div>
              </header>
              {/**MENU*/}
              <MenuIcon
                onClick={this.openDrawer}
                className="btn-sidenav"
                style={{ float: "right" }}
              />
              <p> Administración</p>
              <nav className="navigation">
                <ul className="mainmenu">
                  {this.state.role === "direccion" && (
                    <li>
                      <NavLink to="/direccion">Dirección</NavLink>
                    </li>
                  )}

                  <li>
                    <NavLink to="/home/administracion">
                      Gestión jefes de obra
                    </NavLink>
                    <ul className="submenu">
                      <li>
                        <NavLink
                          to="/jefe/obra/consulta/usuario"
                          activeClassName="active"
                        >
                          {" "}
                          Consultar jefe obra
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/jefe/obra/alta/administracion"
                          activeClassName="active"
                        >
                          {" "}
                          Alta jefe obra
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/jefe/obra/baja/usuario"
                          activeClassName="active"
                        >
                          {" "}
                          Baja jefe obra
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/jefe/obra/modificar/usuario"
                          activeClassName="active"
                        >
                          {" "}
                          Asignar jefe obra
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/home/administracion">
                      Gestión jefes de grupo
                    </NavLink>
                    <ul className="submenu">
                      <li>
                        <NavLink
                          to="/jefe/grupo/consulta/usuario"
                          activeClassName="active"
                        >
                          {" "}
                          Consultar jefe grupo
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/jefe/grupo/administracion"
                          activeClassName="active"
                        >
                          {" "}
                          Alta jefe grupo
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/jefe/grupo/baja/usuario"
                          activeClassName="active"
                        >
                          {" "}
                          Baja jefe grupo
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/jefe/grupo/modificar/usuario"
                          activeClassName="active"
                        >
                          {" "}
                          Asignar jefe grupo
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/home/administracion">
                      Gestión roles usuario
                    </NavLink>
                    <ul className="submenu">
                      <li>
                        <NavLink
                          to="/modificacion/usuario"
                          activeClassName="active"
                        >
                          {" "}
                          Asignar roles usuario
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/proveedores/administracion">
                      Gestión proveedores
                    </NavLink>
                    <ul className="submenu">
                      <li>
                        <NavLink
                          to="/proveedores/consulta"
                          activeClassName="active"
                        >
                          {" "}
                          Consultar proveedor
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/proveedores/administracion"
                          activeClassName="active"
                        >
                          {" "}
                          Alta proveedor
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/proveedores/baja/administracion"
                          activeClassName="active"
                        >
                          {" "}
                          Baja proveedor
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/home/administracion">
                      Gestión facturas
                    </NavLink>
                    <ul className="submenu">
                      <li>
                        <NavLink
                          to="/proveedor/factura/administracion"
                          activeClassName="active"
                        >
                          {" "}
                          Crear factura
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/home/administracion"
                          activeClassName="active"
                        >
                          {" "}
                          Supervisar facturas
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/pedidos">Gestión pedidos</NavLink>
                    <ul className="submenu">
                      <li>
                        <NavLink to="/pedidos" activeClassName="active">
                          {" "}
                          Supervisar pedidos
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                  <li>
                    <NavLink to="/obras"> Gestión de obras</NavLink>
                    <ul className="submenu">
                      <li>
                        <NavLink to="/crear/obra" activeClassName="active">
                          {" "}
                          Alta obra
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/eliminar/obra" activeClassName="active">
                          {" "}
                          Baja obra
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        ) : (
          <>
            <MenuIcon
              onClick={this.openDrawer}
              className="btn-drawer"
              style={{ float: "left" }}
            />
            <p className="submenu-p">Menu</p>
          </>
        )}
      </>
    );
  }
}

export default MenuAdmin;
